/*
|--------------------------------------------------------------------------------------------------
| Dependencies
|--------------------------------------------------------------------------------------------------
*/
import 'sweetalert2';
import 'flatpickr';
import './bootstrap';


/*
|-------------------------------------------------------------------------------------------------
| Vue init
|-------------------------------------------------------------------------------------------------
*/
import './Vue/init';


/*
|--------------------------------------------------------------------------------------------------
| Helpers (Must be required after Vue)
|--------------------------------------------------------------------------------------------------
*/
import './helpers/sweetalert';
import './helpers/navTabAutoSwitcher';
import './helpers/flatpickr';
import clickableRows from './helpers/clickableRows';
import './helpers/sliderSortable';

clickableRows();


/**
 * Auto fill the URL field when you type a title
 *
 * View [page.create]
 */
$('.js-page-title').on('keyup', function () {
  const title = $(this).val();

  let suggestedUrl = title.replace(/\s+/g, '-').toLowerCase();
  suggestedUrl = suggestedUrl.replace(/[æå]/g, 'a');
  suggestedUrl = suggestedUrl.replace(/[ø]/g, 'o');
  suggestedUrl = suggestedUrl.replace(/[^a-z0-9_-]+/gi, '');

  $('.js-page-url').val(suggestedUrl);
});
